export const actions = {
  EMAIL_SIGN_IN_REQUEST_ACTION: 'EMAIL_SIGN_IN_REQUEST_ACTION',
  GOOGLE_SIGN_IN_REQUEST_ACTION: 'GOOGLE_SIGN_IN_REQUEST_ACTION',
  SAVE_ORG_SELECTION_ACTION: 'SAVE_ORG_SELECTION_ACTION'
};

export const emailSignInRequestAction = (email, password) => ({
  type: actions.EMAIL_SIGN_IN_REQUEST_ACTION,
  email,
  password
});

export const googleSignInRequestAction = googleResponse => ({
  type: actions.GOOGLE_SIGN_IN_REQUEST_ACTION,
  googleResponse
});

export const saveOrgSelectionAction = (
  org,
  shouldRedirectToHome = true,
  callback = null
) => ({
  type: actions.SAVE_ORG_SELECTION_ACTION,
  shouldRedirectToHome,
  org,
  callback
});
